"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditNamePartsDto = instanceOfDocumentAuditNamePartsDto;
exports.DocumentAuditNamePartsDtoFromJSON = DocumentAuditNamePartsDtoFromJSON;
exports.DocumentAuditNamePartsDtoFromJSONTyped = DocumentAuditNamePartsDtoFromJSONTyped;
exports.DocumentAuditNamePartsDtoToJSON = DocumentAuditNamePartsDtoToJSON;
exports.DocumentAuditNamePartsDtoToJSONTyped = DocumentAuditNamePartsDtoToJSONTyped;
/**
 * Check if a given object implements the DocumentAuditNamePartsDto interface.
 */
function instanceOfDocumentAuditNamePartsDto(value) {
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
function DocumentAuditNamePartsDtoFromJSON(json) {
    return DocumentAuditNamePartsDtoFromJSONTyped(json, false);
}
function DocumentAuditNamePartsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
function DocumentAuditNamePartsDtoToJSON(json) {
    return DocumentAuditNamePartsDtoToJSONTyped(json, false);
}
function DocumentAuditNamePartsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
//# sourceMappingURL=DocumentAuditNamePartsDto.js.map